"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseURLResponse = exports.parseQueryResponse = void 0;
function parseQueryResponse(input) {
    var _a, _b, _c, _d;
    if (!input)
        return null;
    if (typeof input === "string") {
        if (!input.length)
            return null;
        if (input.startsWith('?') || input.startsWith('#'))
            input = input.substring(1);
        input = new URLSearchParams(input);
    }
    if (input.get('code')) {
        return {
            code: input.get('code'),
            state: (_a = input.get('state')) !== null && _a !== void 0 ? _a : undefined
        };
    }
    if (input.get('id_token')) {
        return {
            id_token: input.get('id_token'),
            state: (_b = input.get('state')) !== null && _b !== void 0 ? _b : undefined
        };
    }
    if (input.get('error')) {
        return {
            error: input.get('error'),
            error_description: (_c = input.get('error_description')) !== null && _c !== void 0 ? _c : undefined,
            state: (_d = input.get('state')) !== null && _d !== void 0 ? _d : undefined
        };
    }
    return null;
}
exports.parseQueryResponse = parseQueryResponse;
function parseURLResponse(input) {
    input = typeof input === "string" ? new URL(input) : input;
    const queryResponse = parseQueryResponse(input.search);
    if (queryResponse)
        return queryResponse;
    return parseQueryResponse(input.hash);
}
exports.parseURLResponse = parseURLResponse;
//# sourceMappingURL=response.js.map